import React, { PropTypes } from 'react'
import { translate } from 'react-i18next'
import SuccessModal from '../../../components/Modal/SuccessModal'
import { resendConfirmationEmail } from '../../..//sources/AuthSources'
import Button from '../../../components/Button'
import styled from 'styled-components'
import { Metrics } from '../../../Themes'

const CustomButton = styled(Button)`
  margin: 0 auto;
  margin-top: ${Metrics.margins.large};
  display: block;

`

const Success = props => {
  const { t, router, profile } = props
  const uploadSuccess = props.location.query.state
  return (
    <SuccessModal
      visible
      backAction={router.goBack}
      closeAction={() => router.push('/landing')}
      header={t('Thank You')}
      message={
        <div>
          {uploadSuccess ? (
            t('The file was uploaded with success.')
          ) : (
            t(
              'You will receive a confirmation e-mail. Please follow the link to activate your account.'
            )
          )}
          {!uploadSuccess && (
            <CustomButton
              secondary
              onClick={() => resendConfirmationEmail(profile.id)}
              label={t('Re-send Confirmation E-mail')}
            />
          )}
        </div>
      }
    />
  )
}

Success.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  profile: PropTypes.object
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  Success
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/Success.js